import {Component, Inject, Input, OnInit} from "@angular/core";
import {AttachmentType} from "../../../../../../pastureProFECommon/projects/common-lib/src/lib/model";
import {Store} from "@ngrx/store";
import {PortalAppState} from "../../../store/reducer";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
  Attachment,
  CommonState,
  CurrentState,
} from "common-lib";
import {AttachmentsPortalService} from "../../../services/attachment-portal.service";

@Component({
  selector: 'attachments-list-page',
  templateUrl: './attachments-list.page.html',
  styleUrls: ['./attachments-list.page.scss']
})
export class AttachmentsListPage implements OnInit {

  description = '';
  attachmentTypes: AttachmentType[];

  constructor(protected store: Store<PortalAppState>,              public dialogRef: MatDialogRef<AttachmentsListPage>,
              @Inject(MAT_DIALOG_DATA) public data: {
                attachments: Attachment[],
                moduleEntityId: number,
              },

              public dialog: MatDialog,
              private currentState: CurrentState<CommonState>,
              private attachmentService: AttachmentsPortalService) {
  }

  ngOnInit(): void {
    this.attachmentTypes = this.currentState.snapshot.attachments.attachmentTypes;
  }

  attachmentClicked(data: { attachment: Attachment, moduleEntityId: number }) {
    this.attachmentService.openAttachments('animal', data.attachment, null, data.moduleEntityId);
  }
}
